import { AlertTriangle, Info } from "lucide-react";
import { cn } from "@/lib/utils";
import { Label } from "@/components/ui/label";

// Field wrapper providing label, required marker, and inline error/warning.
export function Field({ label, htmlFor, required, error, warning, hint, children, className }) {
  return (
    <div className={cn("space-y-1.5", className)}>
      {label && (
        <Label htmlFor={htmlFor} className="text-sm font-medium text-foreground">
          {label}
          {required && <span className="ml-0.5 text-error">*</span>}
        </Label>
      )}
      {children}
      {error ? (
        <p className="flex items-center gap-1.5 text-xs font-medium text-error-dark" data-testid="field-error">
          <AlertTriangle className="h-3.5 w-3.5" />
          {error}
        </p>
      ) : warning ? (
        <p className="flex items-center gap-1.5 text-xs font-medium text-warning-dark" data-testid="field-warning">
          <Info className="h-3.5 w-3.5" />
          {warning}
        </p>
      ) : hint ? (
        <p className="text-xs text-muted-foreground">{hint}</p>
      ) : null}
    </div>
  );
}

export function DrawerSection({ title, children }) {
  return (
    <div className="space-y-4">
      {title && (
        <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          {title}
        </p>
      )}
      {children}
    </div>
  );
}
